import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SchoolModule } from '../../../appshared/Main/school/school.module';
import { SchoolService } from '../../../appshared/Main/school/school.service';

@Component({
  selector: 'app-register-terms',
  templateUrl: './register-terms.component.html',
  styleUrls: ['./register-terms.component.scss']
})
export class RegisterTermsComponent implements OnInit {

    isLoading = true;
    public schools: SchoolModule[] = [];
    constructor(private service: SchoolService, private router: Router) { }

    ngOnInit(): void {
        this.getAllService();
    }

    public getAllService = () => {
        this.isLoading = true;
        this.schools = [];
        this.service.getService()
            .subscribe(res => {
                this.schools = res as SchoolModule[];
            })
        this.isLoading = false;
  }
    public onClickBT() {

        this.router.navigate(['register_details']);

    }
}
